<template>
    <div class="previewClipartContainer" :style="getLineStyle">
         <div class="north">
             <div class="editArea" :style="getEditAreaStyle"></div>
         </div>
    </div>
</template>
<script>
    export default {

        props    : ['clipart','label'],
        computed : {
            getLineStyle () {
              if( this.clipart.rgb != "" && this.label.isReady ) {
                  return {

                      'top'              : this.clipart.top + "px",
                      'left'             : this.clipart.left + "px",
                      'width'            : this.clipart.width + "px",
                      'height'           : this.clipart.height + "px",
                      'background-image' : this.clipart.url != "" ? "url(" + this.$store.getters.strings.getSvgUrl + "?category=" + this.clipart.category + "&filename=" + this.clipart.filename + "&color=" + this.clipart.rgb + ")" : 'none',
                      'z-index'          : this.clipart.zindex
                  }
                  }
              return {
                  'background-image' : 'none',
              };
            },
            getEditAreaStyle () {
                return {
                    'width'  : this.clipart.width + "px",
                    'height' : this.clipart.height + "px",
                }
            },
        }
    }
</script>
<style>
    .previewClipartContainer {
        position            : absolute;
        background          : transparent;
        background-size     : contain;
        background-position : center center;
        background-repeat   : no-repeat;
    }

    .editArea {
        transform-origin : left top;
        white-space      : nowrap;
        overflow         : visible;
    }

    .north {
        width  : 100%;
        height : 100%;
    }
    </style>



// WEBPACK FOOTER //
// src/components/Preview/PreviewClipart.vue